<template>
  <b-modal
    v-model="display"
    :title="title"
    header-bg-variant="info"
    header-text-variant="light"
    header-class="pt-1 pb-2 modal-header-sm rounded-0"
    body-bg-variant="light"
    body-text-variant="dark"
    footer-bg-variant="dark"
    footer-text-variant="light"
    body-class="pt-4 pl-2 pr-1"
    hide-footer
    centered
    :modal-class="fullscreen ? 'modal-fullscreen-xl' : 'modal-fullscreen-md'"
    @close="closeModal()"
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid="md" v-html="content">
    </b-container>
    <b-container v-if="showSentry === true" fluid="md">
      <div class="text-center">
        <b-link to="test_sentry">Sentry</b-link>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
function initialDataModal () {
  return {
    display: false,
    fullscreen: false,
    title: '',
    content: '',
    showSentry: false
  }
}

export default {
  name: 'UserMessage',
  mixins: [],
  props: {},
  components: {},
  data () {
    return initialDataModal()
  },
  methods: {
    openModal () {
      this.display = true
    },
    closeModal () {
      Object.assign(this.$data, initialDataModal())
      this.display = false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$root.$on('openHelpModal', (content, title = this.$t('help'), fullscreen = false, changelog = false) => {
      this.fullscreen = fullscreen
      this.title = title
      if(changelog) {
        this.content = require('../../../CHANGELOG.html').default
        this.showSentry = true
      } else {
        this.content = content
      }
      this.openModal()
    })
    this.$root.$on('closeHelpModal', () => {
      this.closeModal()
    })
  },
  beforeDestroy () {
  },
  destroyed() {
    this.$root.$off('openHelpModal')
    this.$root.$off('closeHelpModal')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
